import React from 'react';

import { BaseCard } from './BaseCard';
import type { CardProps } from './interface';

export function Card(props: CardProps) {
  return <BaseCard {...props} />;
}
